import { createContext, useContext } from "react";
import type { BookPatch, ColoringState } from "./types.js";

/** Shared workspace state handed to every coloring-book panel. */
export interface ColoringCtx {
  projectId: string;
  state: ColoringState;
  /** Re-fetch the whole workspace state. */
  reload: () => Promise<void>;
  /** Save book-level settings and update local state. */
  saveBook: (patch: BookPatch) => Promise<void>;
  /** Jump to another workspace tab. */
  goTo: (tab: ColoringTab) => void;
}

export type ColoringTab = "overview" | "style" | "characters" | "pages" | "cover" | "preview" | "export";

const Ctx = createContext<ColoringCtx | null>(null);

export const ColoringProvider = Ctx.Provider;

export function useColoring(): ColoringCtx {
  const value = useContext(Ctx);
  if (!value) throw new Error("useColoring must be used inside ColoringWorkspace");
  return value;
}
